import script from "./numeric-input.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./numeric-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./numeric-input.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./numeric-input.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__